import type { FC } from "react";
import { Col, Row } from "@viagogo/core/ui";
import { AddFeature, RecordParticipationTypes } from "@viagogo/feature";
import type { CategoryEventListViewModel } from "src/http/api-types";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useAppContext } from "src/shared/context/AppContext";
import { EmailSignUp } from "src/website-apps/shared/components/email-signup";
import { EventListRecentlyViewedGrid } from "src/website-apps/shared/components/event-list-recently-viewed-grid";
import { FiltersAndGridsManager } from "src/website-apps/shared/components/FiltersAndGridsManager";
import { UserEventToastOnAncillaryPages } from "src/website-apps/shared/components/user-event-toast";
import { canShowWorldCupFanProtectDisplay } from "src/website-apps/shared/components/world-cup-fan-protect/eligibility";
import { eventListPlacement } from "src/website-apps/shared/components/world-cup-fan-protect/styles";
import { WorldCupFanProtectDisplay } from "src/website-apps/shared/components/world-cup-fan-protect/WorldCupFanProtectDisplay";
import { MaybeVenuesLinksGrid } from "./MaybeVenuesLinksGrid";
import { BodyWrapper, MarginDivLarge, PaddedContainer, VerticalMarginRow } from "./styled-components";

interface Props {
  model: CategoryEventListViewModel;
}

/**
 * New Version of the LayoutBody Component for Control to Add New Tests in ONLY for Applicable Categories
 */
export const LayoutBody: FC<Props> = ({ model }) => {
  const appContext = useAppContext();
  const { categoryId, categoryName } = model.categorySummary ?? {};
  const canShowWorldCupFanProtect = canShowWorldCupFanProtectDisplay(categoryId, appContext.cobrandId);

  return (
    <>
      <UserEventToastOnAncillaryPages userEventOption={model.userEventOption} />
      <BodyWrapper addPrimaryBgColor $secondaryBgColor>
        <PaddedContainer>
          <Row between={[true]}>
            <Col span={[12]}>
              <AddFeature
                id={FeatureSetEnum.TMWorldCupFanProtectDisplay}
                recordType={RecordParticipationTypes.IN_VIEW}
                canParticipate={() => canShowWorldCupFanProtect}
                feature={() => <WorldCupFanProtectDisplay mode="responsive" className={eventListPlacement} />}
              />
              <FiltersAndGridsManager filterTypeOptions={model.gridFilterTypes} categoryName={categoryName ?? ""} />
              <MarginDivLarge>
                <MaybeVenuesLinksGrid
                  isGrouping={model.isGrouping}
                  categoryName={categoryName ?? ""}
                  venues={model.venues ?? []}
                />
              </MarginDivLarge>
            </Col>
          </Row>
          <Row>
            <EventListRecentlyViewedGrid />
          </Row>
          <VerticalMarginRow>
            {!appContext.isNativeApp && (
              <Col span={[12]}>
                <EmailSignUp emailPrivacyDisclosureSiteMessage={model.privacyPolicyMessage} />
              </Col>
            )}
          </VerticalMarginRow>
        </PaddedContainer>
      </BodyWrapper>
    </>
  );
};
